import { Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider } from '@/components/AuthContext'
import { Layout } from '@/components/Layout'
import { HomePage } from './HomePage'
import { ProfilePage } from './ProfilePage'

function ExternalRedirect({ to }: { to: string }) {
  window.location.href = to
  return null
}

export function MainApp() {
  return (
    <AuthProvider>
      <Layout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/live" element={<ExternalRedirect to="https://live.n0n3.com" />} />
          <Route path="/stats" element={<ExternalRedirect to="https://stats.n0n3.com" />} />
          <Route path="/admin" element={<ExternalRedirect to="https://admin.n0n3.com" />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Layout>
    </AuthProvider>
  )
}
